// extracted by mini-css-extract-plugin
module.exports = {"storeWrapperMobileWhite":"StoreProductWrapper_storeWrapperMobileWhite__Hp99P","footerWrap":"StoreProductWrapper_footerWrap__kyAZq"};